import apiClient from "./config";
import { FILE_MANAGER_ENDPOINTS } from "./endpoints";

// Folder
export const getFolders = (folder) => apiClient.get(FILE_MANAGER_ENDPOINTS.GET_FOLDERS, folder);
export const deleteFolder = (folder) => apiClient.delete(FILE_MANAGER_ENDPOINTS.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder) => apiClient.create(FILE_MANAGER_ENDPOINTS.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder) => apiClient.put(FILE_MANAGER_ENDPOINTS.UPDATE_FOLDER, folder);

// File
export const getFiles = (file) => apiClient.get(FILE_MANAGER_ENDPOINTS.GET_FILES, file);
export const deleteFile = (file) => apiClient.delete(FILE_MANAGER_ENDPOINTS.DELETE_FILE, { headers: { file } });
export const addNewFile = (file) => apiClient.create(FILE_MANAGER_ENDPOINTS.ADD_NEW_FILE, file);
export const updateFile = (file) => apiClient.put(FILE_MANAGER_ENDPOINTS.UPDATE_FILE, file);

